jQuery(document).ready(function ($)
{
	// Odometer JS
	// ============================================================================

	// https://github.com/HubSpot/odometer
	// https://github.hubspot.com/odometer/docs/welcome/

	const $statsCounters = $( '[data-statscounter-number]' );

	$(window).on('scroll load', function(){
		checkCounters();
	});

	function checkCounters() {
		$statsCounters.each( ( i, el ) =>
		{
			if ( isInViewport( el ) )
			{
				const $el = $( el );
				const targetNum = $el.attr( 'data-statscounter-number' );
				$el.html( targetNum );
			}
		});
	}

	function isInViewport(element) {
		var elementTop     = $(element).offset().top;
		var elementBottom  = elementTop + $(element).outerHeight();

		var viewportTop    = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	}





	// OLD
	// ============================================================================

	/*
	function animateCounter($el) {
		if ($el.hasClass('counted')) return;

		var rawValue = $el.data('statscounter-number').toString();
		var number = parseInt(rawValue.replace(/\D/g,'')); // strip + etc
		var suffix = rawValue.replace(/[0-9]/g,''); // keep + etc

		$el.addClass('counted');

		$({ countNum: 0 }).animate({ countNum: number }, {
			duration: 2000,
			easing: 'swing',
			step: function() {
				$el.text(Math.floor(this.countNum) + suffix);
			},
			complete: function() {
				$el.text(this.countNum + suffix);
			}
		});
	}
	*/
});
